import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon, DownloadIcon } from 'lucide-react';
import { SelectedPlan } from '../../data/pricingPlans';
import { downloadTermsPdf, termsHighlightsFor } from '../../utils/termsPdf';
type TermsStageProps = {
  accepted: boolean;
  showError: boolean;
  backLabel: string;
  plan?: SelectedPlan | null;
  onBack: () => void;
  onAcceptChange: (accepted: boolean) => void;
  onSubmit: () => void;
};
export function TermsStage({
  accepted,
  showError,
  backLabel,
  plan,
  onBack,
  onAcceptChange,
  onSubmit
}: TermsStageProps) {
  const termsHighlights = termsHighlightsFor(plan);
  return <div className="mt-6" data-id="element-301" data-mp="1xutbuc50ewn5">
      <button type="button" onClick={onBack} className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#5B5299] transition hover:text-[#041F60] focus:underline focus:outline-none" data-id="element-302" data-mp="1xv2s38095pfn">
        <ArrowLeftIcon size={15} aria-hidden="true" data-id="element-303" data-mp="10edu5pefb7bj" /> {backLabel}
      </button>

      <div className="mt-5 rounded-xl border border-[#A6B6F8]/60 bg-[#A6B6F8]/15 p-4" data-id="element-304" data-mp="10c9tdgbtmofh">
        <p className="text-sm font-bold text-[#041F60]" data-id="element-305" data-mp="gy27xe27b415">Key terms</p>
        <ul className="mt-3 space-y-2.5" data-id="element-306" data-mp="kyuhy9iwdcyh">
          {termsHighlights.map(highlight => <li key={highlight.title} className="flex gap-2.5" data-id="element-307" data-mp="pqcjayou1fjz">
              <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-[#041F60]" aria-hidden="true" data-id="element-308" data-mp="uppfwb5ia0zr" />
              <p className="text-sm leading-5 text-[#3A3A3A]" data-id="element-309" data-mp="3u65jtogf27rv">
                <span className="font-semibold text-[#041F60]" data-id="element-310" data-mp="20i6gh4ijqzq">
                  {highlight.title}
                </span>{' '}
                — {highlight.detail}
              </p>
            </li>)}
        </ul>
      </div>

      <button type="button" onClick={() => downloadTermsPdf(plan)} className="mt-4 inline-flex w-full items-center justify-center gap-2 rounded-lg border border-[#041F60] bg-white px-4 py-3 text-sm font-bold text-[#041F60] transition hover:bg-[#A6B6F8]/15 focus:outline-none focus:ring-2 focus:ring-[#4BE4FF] focus:ring-offset-2" data-id="element-311" data-mp="c00o2qwyb0om">
        <DownloadIcon size={16} aria-hidden="true" data-id="element-312" data-mp="srnrwmna6twm" />
        Download full terms (PDF)
      </button>

      <div className="mt-5 rounded-xl border border-[#A6B6F8]/60 bg-white p-4" data-id="element-313" data-mp="17oydiotn1g62">
        <label htmlFor="terms-accept" className="flex cursor-pointer items-start gap-3" data-id="element-314" data-mp="12pbyqay5vrv5">
          <input id="terms-accept" type="checkbox" checked={accepted} onChange={event => onAcceptChange(event.target.checked)} aria-describedby={showError ? 'terms-accept-error' : undefined} className="mt-0.5 h-4 w-4 shrink-0 rounded border-[#A6B6F8] text-[#041F60] accent-[#041F60] focus:outline-none focus:ring-2 focus:ring-[#4BE4FF] focus:ring-offset-2" data-id="element-315" data-mp="ez7xubccy67u" />
          <span className="text-sm leading-5 text-[#3A3A3A]" data-id="element-316" data-mp="3sd2scwp9cqti">
            I have read and approve the Credit Manager{' '}
            <span className="font-semibold text-[#041F60]" data-id="element-317" data-mp="3ndq90lxli1vo">
              terms and conditions
            </span>
            , including the first-day trial and 12-month contract period.
          </span>
        </label>
      </div>

      {showError && <p id="terms-accept-error" role="alert" className="mt-3 text-sm font-medium text-rose-600" data-id="element-318" data-mp="1t0du3enbkbif">
          Please approve the terms and conditions to continue.
        </p>}

      <button type="button" disabled={!accepted} onClick={onSubmit} className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-lg bg-[#041F60] px-4 py-3.5 text-sm font-bold text-white transition enabled:hover:bg-[#031849] focus:outline-none focus:ring-2 focus:ring-[#4BE4FF] focus:ring-offset-2 disabled:cursor-not-allowed disabled:bg-stone-300" data-id="element-319" data-mp="2lot2vjfuxxlb">
        Agree and submit <ArrowRightIcon size={17} aria-hidden="true" data-id="element-320" data-mp="11aizp3kltvmw" />
      </button>
    </div>;
}